<template>
  <div class="page">
    <!-- 头部 -->
    <Header></Header>
    <!-- 新闻列表 -->
    <div class="product">
      <ul class="infiniteUl" id="refreshScroll">
        <nut-infiniteloading
          pull-icon="refresh"
          container-id="refreshScroll"
          :is-open-refresh="true"
          :has-more="refreshHasMore"
          load-icon='more-x'
          @load-more="refreshLoadMore"
          @refresh="refresh">
          <li
            class="infiniteLi"
            v-for="(item, index) in productList"
            :key="index">
            <router-link :to=" { path:'/productDetails', query: {id: item.id} } ">
              <div class="product_item">
                <div class="product_card_text">
                  <p class="product_title">{{ item.title }}</p>
                  <p class='product_desc'>{{ item.synopsis }}</p>
                </div>
                <img :src="item.coverImage" alt="">
              </div>
            </router-link>


            </li>
        </nut-infiniteloading>
      </ul>
    </div>
  </div>
</template>
<script>
import Header from "@/components/page/Header.vue";
import { Toast } from '@nutui/nutui';
import { getProductList } from "@/api/app.js";
export default {
  components: {
    Header
  },
  data() {
    return {
      refreshHasMore: true,
      queryParams: {
        limit: 10,
        page: 1
      },
      productList: [],
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      getProductList(this.queryParams).then(res => {
        this.productList = this.productList.concat(res.list);
        if (this.productList.length >= res.total) this.refreshHasMore = false
      });
    },
    // 下拉刷新
    refresh(done) {
      setTimeout(()=>{
        // Toast.success('刷新成功');
        this.queryParams.page = 1;
        this.refreshHasMore = true;
        this.productList = [];
        this.init()
        done();
      },1000)
    },
    // 加载更多
    refreshLoadMore(done) {
      setTimeout(() => {
        this.queryParams.page ++;
        this.init();
        done()
      }, 500);
    },
  },
}
</script>
<style scoped>
.infiniteUl {
  width: 100%;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.page .product {
  margin-top: 125px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.product_item {
  margin-bottom: 30px;
  background: #f8f8f8;
  position: relative;
  overflow: hidden;
  /* height: 670px; */
}
.product_item img {
  display: block;
  width: 686px;
  height: 350px;
}
.product_card_text {
  position: absolute;
  bottom: 20px;
  left: 30px;
  color: #fff;
  z-index: 999;
}
.product_title {
  line-height: 45px;
  font-size: 30px;
  font-weight: 800;
  cursor: pointer;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.product_desc {
  line-height: 24px;
  margin-top: 4px;
  font-size: 16px;
  color: #dddddd;
  cursor: pointer;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

</style>